import React, { useMemo } from 'react';
import { getRandomCardImage } from '../../assets/oracle/deck';

// 1. Disposición de 5 cartas en Cruz (Arriba, Izquierda, Centro, Derecha, Abajo)
export const CardCrossLayout = () => {
  const cards = useMemo(() => {
    return [...Array(5)].map(() => getRandomCardImage());
  }, []);

  return (
    <div className="relative w-40 h-44 mx-auto">
      {/* 1. Arriba */}
      <img
        src={cards[0]}
        alt="Carta Arriba"
        className="absolute top-1 left-1/2 -translate-x-1/2 h-[50px] w-auto object-contain rounded-sm shadow-md border border-gray-600/70 bg-gray-900 transition-transform duration-300 group-hover:scale-105"
      />

      {/* 2. Izquierda */}
      <img
        src={cards[1]}
        alt="Carta Izquierda"
        className="absolute top-1/2 left-2 -translate-y-1/2 h-[50px] w-auto object-contain rounded-sm shadow-md border border-gray-600/70 bg-gray-900 transition-transform duration-300 group-hover:scale-105"
      />

      {/* 3. Centro (con mayor z-index para destacar) */}
      <img
        src={cards[2]}
        alt="Carta Centro"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[52px] w-auto object-contain rounded-sm shadow-xl border border-amber-400/60 bg-gray-900 transition-transform duration-300 group-hover:scale-110 z-10"
      />

      {/* 4. Derecha */}
      <img
        src={cards[3]}
        alt="Carta Derecha"
        className="absolute top-1/2 right-2 -translate-y-1/2 h-[50px] w-auto object-contain rounded-sm shadow-md border border-gray-600/70 bg-gray-900 transition-transform duration-300 group-hover:scale-105"
      />

      {/* 5. Abajo */}
      <img
        src={cards[4]}
        alt="Carta Abajo"
        className="absolute bottom-1 left-1/2 -translate-x-1/2 h-[50px] w-auto object-contain rounded-sm shadow-md border border-gray-600/70 bg-gray-900 transition-transform duration-300 group-hover:scale-105"
      />
    </div>
  );
};

// 2. Disposición en abanico habitual
export const CardStack = ({ count = 3 }) => {
  const cards = useMemo(() => {
    return [...Array(count)].map(() => getRandomCardImage());
  }, [count]);

  return (
    <div className="relative h-full flex items-center justify-center w-full">
      {cards.map((imgSrc, i) => {
        const offset = i - Math.floor(count / 2);
        const rotation = offset * 8;
        const translateX = offset * 14;
        const translateY = Math.abs(offset) * 2;
        const scale = 1 - Math.abs(offset) * 0.02;

        return (
          <img
            key={i}
            src={imgSrc}
            alt={`Carta ${i}`}
            className="absolute h-full w-auto object-contain rounded-md shadow-xl border border-gray-600/60 bg-gray-900 transition-transform duration-300 group-hover:scale-110"
            style={{
              zIndex: i,
              transformOrigin: '50% 90%',
              transform: `translateX(${translateX}px) translateY(${translateY}px) rotate(${rotation}deg) scale(${scale})`,
              left: 0,
              right: 0,
              margin: '0 auto',
            }}
          />
        );
      })}
    </div>
  );
};

// Componente inteligente de renderizado
export const OracleCardPreview = ({ item }) => {
  if (item.layout === 'cross') {
    return <CardCrossLayout />;
  }

  if (item.cardCount && item.cardCount > 1) {
    return <CardStack count={item.cardCount} />;
  }

  if (item.image) {
    return (
      <img
        src={item.image}
        alt={item.title || 'Icono'}
        className="w-full h-full object-contain rounded-md shadow-md"
      />
    );
  }

  return null;
};

export default OracleCardPreview;